import '@/globals.css';
import '@/index.css';
import '@/lib/rum';
import {AppProps} from 'next/app';
import {StrictMode, createContext, useEffect} from 'react';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';
import store from '../Core/mobx/RootStore';
import {GlobalError} from '@/components/global-error';
import {AppAbFlag} from '@amplify/athena-models';

const queryClient = new QueryClient();

const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#456d69',
        },
    },
});

export const RootStoreContext = createContext(store);

interface MyAppProps extends AppProps {
    pageProps: {
        abFlagScheme?: AppAbFlag[];
    };
}

export default function App({Component, pageProps}: MyAppProps) {
    useEffect(() => {
        // Initialize AB flags when app loads
        if (!store.abFlagsStore.isInitialized) {
            // Will use provided schema or fall back to backup
            store.abFlagsStore.initializeFlags(pageProps.abFlagScheme);
        }
    }, [pageProps.abFlagScheme]);
    return (
        <StrictMode>
            <ThemeProvider theme={theme}>
                <GlobalError>
                    <QueryClientProvider client={queryClient}>
                        <RootStoreContext.Provider value={store}>
                            <Component {...pageProps} />
                        </RootStoreContext.Provider>
                        <ReactQueryDevtools initialIsOpen={false} position="bottom-left" />
                    </QueryClientProvider>
                </GlobalError>
            </ThemeProvider>
        </StrictMode>
    );
}
